<template>
  <tile class="opc-zmone opc-zmone--delta" :class="{
    'opc-zmone-delta-modal': $context.is.modalDelta
  }">
    <PlanDetail v-show="false" ref="planDetail" />
    <foldable
      v-model="isExpanded"
      :title="title"
      :arrow="canExpand"
      :edit="canExpand"
      :isRemoveWrapAriaLabelledby="true"
    >
      <template #head>
      <div>
        <div class="opc-zm-base-card__head">
          <div class="opc-zm-base-card__head-left">
            <img class="opc-zm-base-card__logo" :src="logo" :alt="title" />
          </div>
          <div class="opc-zm-base-card__head-right">
            <div class="opc-zm-base-card__head-right-content">
              <h2 class="opc-zm-base-card__name text-capitalize">
                {{ title }}
              </h2>
              <div v-if="isExpanded && $context.is.modal">
                <zm-button data-testid="checkout-button-136" class="opc-zm-base-card__link" type="link" @click="viewCurrent">
                  {{ $t('billing.delta.cur_plan_details') }}
                </zm-button>
              </div>
            </div>
            <div v-html="expandedPlanDesc" class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset" v-if="!isExpanded && formPlan">
            </div>
          </div>
        </div>
      </div>
      </template>
      <div class="opc-zmone__main">
        <zm-form ref="zmoneForm" label-position="top" class="opc-config-form" @submit.prevent>
          <subscription-switch @switch-plan="handleSwitchOldPlan" />
          <zm-form-item :label="$context.is.modal ? $t('billing.delta.buy_more_licenses') : $t('billing.delta.add_user')">
            <div v-if="$context.is.modal" class="opc-zmone__form-modal-tips">
              <span>{{ deltaCurUserTipsForModal }}</span>
            </div>
            <div v-else class="opc-zmone__form-modal-tips">
               <span>{{ curUsersDesc }}</span>
              <zm-button data-testid="checkout-button-137" class="opc-zm-base-card__link" type="link" @click="viewCurrent">
                {{ $t('billing.delta.cur_plan_details') }}
              </zm-button>
            </div>
            <div class="opc-zmone__form-input-wrapper">
              <div class="opc-zmone__form-input-wrapper-left">
                <InputNumberWithPopover
                  class="opc-zmone__quantity-selector"
                  v-model="deltaForm.selectedNumber"
                  size="lg"
                  controls-position="both"
                  :min="1"
                  :max="maxHost"
                  :label="`${title} Select the number of users`"
                  :decrease-tips="popUpDecreaseTips"
                  :increase-tips="increaseTips"
                  :data-testid="`checkout-input-license-${formPlan ? formPlan.plan_code : ''}`"
                />
                <span class="opc-modal-tips-title" v-if="$context.is.modal">
                  {{ $t('billing.delta.new_licenses_desc', deltaForm.selectedNumber) }}
                </span>
              </div>
              <span class="opc-modal-billing-cycle" v-if="$context.is.modal">
                <span class="opc-modal-billing-cycle-price">
                  {{ currentBillingCyclePrice }}
                </span>
                <span class="opc-modal-cycle-info" v-html="billingText"></span>
              </span>
            </div>
          </zm-form-item>
          <zm-form-item class="opc-config-form__last-item" v-if="!$context.is.modal">
            <zm-radio-group
              v-model="form.billingCycle"
              class="opc-card-radio"
              :aria-label="`${title} Billing Cycle`"
              @change="submitForm"
            >
              <zm-radio
                v-for="plan in currentPlans"
                data-testid="checkout-radio-138"
                :key="plan.billing_cycle"
                :label="plan.billing_cycle"
                :disabled="billingCycleDisabled(plan)"
                class="opc-zmone__radio"
              >
                <p class="opc-zmone__radio-title">
                  {{ $t(`billing.billing_cycle.${plan.billing_cycle}`) }}
                </p>
                <p class="opc-product-price-container" tabindex="-1">
                  <span class="opc-product-price-container__price" aria-hidden="true">
                    {{ getFormattedPriceOfMonth(plan, { forceDiff: true }) }}
                  </span>
                </p>
                <p
                  class="opc-zmone__radio-price-unit opc-price-bill-text"
                 >
                <span v-html="getMergedBilledText(plan.billing_cycle, plan.amount)"></span><priceVATTip />
                </p>
              </zm-radio>
            </zm-radio-group>
          </zm-form-item>
          <preview-payment />
        </zm-form>
      </div>
    </foldable>
  </tile>
</template>

<script>
import { pageConfig } from '@/common/service/page-config';
import { ZOOM_MEETING_SUB_TYPES } from '../common/utils';
import edit from './edit.vue';
import { mapGetters } from 'vuex';
import { plansof } from '@/utils/chain';
import offerNotEligible from '@/components/offer-not-eligible';
import { categories } from '../cart.vue';
import { PLAN_PRICE_CHANGE_UTILS } from '@/common/priceChange';
import { PREVIEW_ACTION_TYPES } from '@/store/modules/preview';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import PlanDetail from '../cart.vue';
import ViewCurrentDialog from '@/components/view-current-dialog';

import { getPlanUnitWithCycle, planUnitMap, getBillTextByCycle } from '@/common/product-unit';
import deltaCondition from '@/plans/ZOOM_MEETING/mixin/delta-condition';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { getPlanCollapseText } from '@/common/product';
import { getPlanUnitByQuantity } from '@/common/product-unit';
import { getEffectiveAmount } from '@/utils/downsell-price';
import { formatPriceWithPriceProperties } from '@/utils/money';
import SubscriptionSwitch from '../components/subscription-switch.vue';

export default {
  mixins: [edit, deltaCondition],
  created() {
    this.viewCurrentDialog = new ServiceConfirm(ViewCurrentDialog);
  },
  data() {
    return {
      deltaForm: {
        selectedNumber: 1,
      },
    };
  },
  computed: {
    ...mapGetters(['preloadCartInfo', 'planMapFlatRaw', 'hasPendingRequest', 'boughtPlans', 'getSelectedPlans']),
    deltaCurUserTipsForModal() {
      const userQuantity = this.boughtMeetingPlan.cartInfo.selected_number;

      if (this.form.category === ZOOM_MEETING_SUB_TYPES.PRO) {
        return userQuantity > 1 ? this.$t('billing.delta.cur_users_modal_multiple', { X: userQuantity })
          : this.$t('billing.delta.cur_users_modal_single');
      }

      return this.$t('billing.prorated.cur_users', [userQuantity, getPlanUnitByQuantity(planUnitMap.user, userQuantity)]);
    },
    currentEditPlan() {
      return this.currentPlans.find((p) => p.plan_code === this.oldPlanCode);
    },
    currentBillingCyclePrice() {
      const info = this.getPriceOfMonthWithDownsell(this.currentEditPlan);
      return formatPriceWithPriceProperties(info);
    },
    billingText() {
      const amount = getEffectiveAmount(this.currentEditPlan);
      return this.getMergedBilledText(this.currentEditPlan.billing_cycle, amount, planUnitMap.license);
    },
    mimicProratedCharges() {
      const plan = plansof(this.getSelectedPlans).type(planTypes.ZOOM_MEETING).get(0); // this is edit flow
      const $vm = this.$refs.planDetail;
      const deltaAmount = $vm?.mx_price_delta?.(plan) ?? 0;
      const deltaLicense = $vm?.mx_license_delta?.(plan) ?? 0;
      const boughtLicense = $vm?.mx_license_bought?.(plan) ?? 1;
      // getters.getTaxTotalAmount is polluted by INR checkout
      const getTaxTotalAmount = this.$store.state.Tax.taxes.reduce((acc, x) => {
        const planTax = x.tax.reduce((acc, y) => {
          return acc + y.taxAmount;
        }, 0);
        return acc + planTax;
      }, 0);
      const proratedTax = (getTaxTotalAmount * deltaLicense) / (deltaLicense + boughtLicense);
      const totalAmount = deltaAmount + proratedTax;
      return {
        amount: 0,
        taxAmount: proratedTax,
        totalAmount,
      };
    },
    maxHost() {
      return this.maxHostInfo.max;
    },
    maxHostInfo() {
      if (this.$context.is.modal && this.form.category === ZOOM_MEETING_SUB_TYPES.PRO) {
        return {
          max: 99,
          tips: this.$t('billing.error.cant_add_100'),
        };
      }
      return {
        max: 9999,
        tips: '',
      };
    },
    expandedPlanDesc() {
      const quantity = this.deltaForm.selectedNumber;
      // const amount = this.$money(this.formPlan ? this.formPlan.amount : 0);

      return getPlanCollapseText({
        quantity,
        amount: this.formPlan?.amount ?? 0,
        billingCycle: this.form.billingCycle,
        cycleValue: this.formPlan?.cycleValue,
        unit: this.formPlan?.unit,
      });
    },
    curUsersDesc() {
      const number = this.boughtMeetingPlan.cartInfo.selected_number;
      return this.$t('billing.delta.cur_users', number,{ named: { number } });
    }
  },
  components: {
    PlanDetail,
    SubscriptionSwitch,
  },
  watch: {
    mimicProratedCharges: {
      deep: true,
      async handler() {
        // todo can use implemented prorated price, remove this watch
        if (this.$context.is.modalDelta) return;

        this.$nextTick(() => {
          this.$store.dispatch(PREVIEW_ACTION_TYPES.resetProratedCharges);
          this.$store.commit('setProratedChargeAmount', this.mimicProratedCharges.amount);
          this.$store.commit('setProratedChargeTaxAmount', this.mimicProratedCharges.taxAmount);
          this.$store.commit('setProratedChargeTotalAmount', this.mimicProratedCharges.totalAmount);
        });
      },
    },
    'deltaForm.selectedNumber': {
      handler() {
        this.$nextTick(() => {
          this.updateSelectedNumber();
        });
      },
    },
  },
  methods: {
    getPlanUnitWithCycle(billingCycle) {
      return getPlanUnitWithCycle(billingCycle, this.$context.is.modalDelta ? planUnitMap.license : planUnitMap.user);
    },
    init() {
      // cart builder plan planCode is not accurate due to different billing cycle that sales rep may choose
      // we need to get added quantity from the cart builder plan of current edit type
      const preCondition = this.getDeltaPreCondition();
      if (!preCondition) return offerNotEligible();
      // keep original cartid build delta logic
      if (this.$context.is.delta) {
        setTimeout(() => { // delay this to the end, because Audio Conferencing is watching on getSelectedPlans change per @Chase Xu
        // disable scenarios with incidental plans, e.g. US & CA Audio Conferencing
        if (this.getSelectedPlans?.length > 1) {
          return offerNotEligible();
        }
        }, 0);
      }

      const oldPlanCode = pageConfig.oldPlanCode;
      const currentEditPlan = this.planMapFlatRaw.find((x) =>
        [oldPlanCode, PLAN_PRICE_CHANGE_UTILS.getOtherPlanCodeForPriceChange(oldPlanCode)].includes(x.plan_code),
      );
      const editPlanType = currentEditPlan?.type;
      const editPlanCategory = currentEditPlan?.category;
      if (!editPlanType || !editPlanCategory) return;
      const plansOfEditType = plansof(this.planMapFlatRaw).type(editPlanType).category(editPlanCategory).get();
      const allPlanCodesOfEditType = plansOfEditType.map((x) => x.plan_code);
      const changedPriceCodes = allPlanCodesOfEditType.map((planCode) =>
        PLAN_PRICE_CHANGE_UTILS.getOtherPlanCodeForPriceChange(planCode),
      );
      // * addQty case
      if (this.$context.is.modal && this.$context.is.addQty) {
        const boughtMeetingPlanSelectedNumber = this.boughtMeetingPlan?.cartInfo?.selected_number;
        // ! note currentEditPlan here is the current edit plan(selected Plan), which is not same as the currentEditPlan in vuex (boughtPlans).
        const currentEditPlanSelectedNumber = this.currentEditPlan?.cartInfo?.selected_number;
        const addQty = currentEditPlanSelectedNumber - boughtMeetingPlanSelectedNumber;
        this.deltaForm.selectedNumber = Number(addQty) > 0 ? Number(addQty) : 1;
      } else {
        const cartPlans = this.preloadCartInfo?.orderData?.planList;
        const targetPlan = cartPlans?.find((x) =>
          [...changedPriceCodes, ...allPlanCodesOfEditType].includes(x.planCode),
        );
        if (!targetPlan) {
          const allPlansOfEditType = plansof(this.planMapFlatRaw).type(editPlanType).get();
          const offeredPlanCategory =
            allPlansOfEditType.find((x) => {
              const cartPlanCodes = cartPlans.map((x) => x.planCode);
              const planCode = x.plan_code;
              const priceChangePlanCode = PLAN_PRICE_CHANGE_UTILS.getOtherPlanCodeForPriceChange(planCode);
              return cartPlanCodes.includes(x.plan_code) || cartPlanCodes.includes(priceChangePlanCode);
            })?.category ?? '';
          return offerNotEligible(
            offeredPlanCategory &&
              `${this.$t('billing.delta.offer_exclusive_to', [this.$t(categories[offeredPlanCategory] ?? '')])}`,
          );
        }
        this.deltaForm.selectedNumber = Math.max(targetPlan.quantity, 1);
      }
      this.updateSelectedNumber();
    },
    updateSelectedNumber() {
      const selectedNumber = (this.boughtMeetingPlan?.cartInfo?.selected_number ?? 0) + this.deltaForm.selectedNumber;
      this.form.selectedNumber = selectedNumber;
      this.submitForm(selectedNumber);
    },
    async viewCurrent() {
      this.$tracking.buyInteraction('view current plan details selected', this.title);
      this.viewCurrentDialog.confirm({ planType: planTypes.ZOOM_MEETING });
    },
    getBillTextByCycle(billingCycle) {
      if (billingCycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY) {
        return `${this.$t('billing.bill_12_payments')}, ${getBillTextByCycle(billingCycle)}`;
      }
      return getBillTextByCycle(billingCycle);
    },
    handleSwitchOldPlan({ billingCycle, licenses }) {
      this.$nextTick(() => {
        this.form.billingCycle = billingCycle;
        this.form.selectedNumber = licenses;
        this.init();
      });
    },
  },
  mounted() {
    setTimeout(this.init, 0);
  },
};
</script>

<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';
.opc-zmone--delta {
  .opc-zmone__main {
    color: var(--zoom-color-text-strong-neutral, #555B62);
  }

  .opc-card-radio {
    @include media(desktop) {
      width: 50%;
    }
    .opc-price-save-count {
      display: none;
    }
    .zbo-radio__wrap.is-checked {
      .zbo-radio__label--inner {
        border: 1px solid #b8b8c4;
      }
      &:after {
        display: none;
      }
    }
    .zbo-radio__wrap:not(.is-checked) {
      display: none;
    }
    :has(.zbo-radio__wrap:not(.is-checked)) {
      display: none;
    }
  }
  .opc-zmone__main {
    .opc-config-form {
      .opc-zmone__form-modal-tips {
        display: flex;
        justify-content: start;
        align-items: baseline;
        margin-top: 4px;
        .opc-zm-base-card__link {
          margin-left: 4px;
        }
      }
      .opc-zmone__form-input-wrapper {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-top: 8px;

        &-left {
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
        }

        .opc-zmone__quantity-selector {
          margin-top: 0;
        }
      }
    }
    .opc-modal-tips-title {
      font-size: 14px;
      font-weight: 400;
      margin: 0 8px;
      flex-shrink: 0;
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      line-height: 18px; /* 128.571% */
      letter-spacing: -0.15px;
    }
    .opc-modal-billing-cycle {
      margin-left: 40px;
      display: inline-flex;
      flex-wrap: wrap;
      column-gap: 6px;
      align-items: baseline;
      padding-top: 8px;

      .opc-modal-billing-cycle-price {
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
        font-size: 20px;
        font-weight: 600;
        line-height: 24px; /* 120% */
        letter-spacing: -0.45px;
      }
      .opc-modal-cycle-info {
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
        font-size: 14px;
        font-weight: 400;
        line-height: 18px; /* 128.571% */
        letter-spacing: -0.15px;
      }
    }
  }
}

.opc-zmone--delta {
  &.opc-zmone-delta-modal {
    .opc-zm-base-card__name {
      @include media(mobile, tablet) {
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%; /* 30px */
      }
    }

    .opc-zm-base-card__collapse {
      margin-top: 0px;
    }
  }

  .zbo-form-item.opc-config-form__last-item {
    .zbo-form-item__row {
      .zbo-form-item__label-wrapper {
        height: 0px;
      }

      .zbo-radio__wrap.is-checked {
        border: 1px solid #b8b8c4;
      }
    }
  }
}

</style>
